import { parse } from "@conform-to/zod";
import { ActionFunctionArgs, json } from "@remix-run/node";
import { useFetcher, useParams } from "@remix-run/react";
import { z } from "zod";

import { createServerStateManager } from "~/modules/StateManager.server";

const schema = z.object({ timeZone: z.string() });

export async function action(args: ActionFunctionArgs) {
  const stateManager = await createServerStateManager(args);

  const formData = await args.request.formData();
  const result = parse(formData, { schema });
  await stateManager
    .setState((draft) => {
      draft.timetable.timeZone = result.value?.timeZone;
    })
    .persist();

  return json({ ok: true });
}

export function useTimezoneUpdater() {
  const { enterprise, sessionId } = useParams<"sessionId" | "enterprise">();
  const fetcher = useFetcher<typeof action>();

  return (timeZone: string) => {
    const formData = new FormData();
    formData.set("timeZone", timeZone);

    fetcher.submit(formData, {
      method: "post",
      action: `/${enterprise}/plugin/${sessionId}/api/timetable-timezone`,
    });
  };
}
